import React from "react";
import * as _ from "lodash";
import "../../css/page.css";
import MediaQuery from "react-responsive";
import {
  Event,
  EventDetailsContainer,
  EventDescription,
  EventDate,
  EventAddress,
  EventTitle,
  EventVideo,
  EventVideoLogo,
} from "./styled_event_details";
import { Container, CenteredContent } from "../../styles/base";
import videoPlaceholder from "../../assets/img/video_placeholder.jpg";
import videoPlaceholderMobile from "../../assets/img/video_placeholder_mobile.jpg";
import videoDesktop from "../../assets/video/hero_video_desktop.mp4";
import videoMobile from "../../assets/video/hero_video_mobile.mp4";
import videoLogo from "../../assets/img/it_30th_anniversary_logo.png";
import videoLogo2x from "../../assets/img/it_30th_anniversary_logo@2x.png";
import videoLogo3x from "../../assets/img/it_30th_anniversary_logo@3x.png";
import translations from "../../locales";
import getLocale from "../../helpers/getLocale";

export class EventDetails extends React.Component {
  render() {
    const locale = getLocale();
    const title = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.event_details.title"
    );
    const description_1 = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.event_details.description_1"
    );
    const description_2 = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.event_details.description_2"
    );
    const description_3 = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.event_details.description_3"
    );
    const address = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.event_details.address"
    );
    const eventDate = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.event_details.date"
    );

    return (
      <Event>
        <MediaQuery minWidth={768}>
          <EventVideo>
            <video loop playsInline autoPlay muted poster={videoPlaceholder}>
              <source src={videoDesktop} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <EventVideoLogo src={videoLogo} srcset={`${videoLogo2x} 2x, ${videoLogo3x} 3x`} />
          </EventVideo>
        </MediaQuery>
        <MediaQuery maxWidth={767}>
          <EventVideo>
            <video loop playsInline autoPlay muted poster={videoPlaceholderMobile}>
              <source src={videoMobile} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <EventVideoLogo src={videoLogo} srcset={`${videoLogo2x} 2x, ${videoLogo3x} 3x`} />
          </EventVideo>
        </MediaQuery>
        <EventDetailsContainer>
          <EventTitle>
            <div lang={locale}>{title}</div>
          </EventTitle>
          <CenteredContent maxWidth="570px">
            <Container center>
              <div className="carousel-inner" role="listbox">
                <div className="item active text">
                  <CenteredContent maxWidth="570px">
                    <EventDescription block lang={locale}>
                      {description_1}<br /><br />
                      {description_2}<br /><br />
                      {description_3}<br /><br />
                    </EventDescription>
                    <EventAddress block lang={locale}>
                      {address}
                    </EventAddress>
                    <EventDate block lang={locale}>
                      {eventDate}
                    </EventDate>
                  </CenteredContent>
                </div>
              </div>
            </Container>
          </CenteredContent>
        </EventDetailsContainer>
      </Event>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/event_details/event_details.js